const initialState = {
  user: {
    id: null,
    username: null,
    name: null,
  },
  token: null,
  refresh: null,
  isAuthenticated: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      // console.log("STATE:", state);
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.refresh = action.payload.refresh;
      state.isAuthenticated = action.payload.token ? true : false;
      break;
    case "LOGOUT":
      // console.log("STATE:", state);
      state.user = initialState.user;
      state.token = null;
      state.isAuthenticated = false;
      break;
    case "UPDATE_USER":
      // console.log("STATE:", state);
      state.user = action.payload;
      break;
    default:
    // console.log("State", state);
  }
  return state;
};
